import { useEffect } from "react";

/**
 * Tiny SEO helper for SPAs.
 * Sets document.title, <meta name="description">, and <link rel="canonical">
 * per route. Restores previous values on unmount.
 */
export default function useSeo({ title, description, path }) {
  useEffect(() => {
    const prevTitle = document.title;
    if (title) document.title = title;

    const setMeta = (name, content) => {
      if (!content) return null;
      let tag = document.querySelector(`meta[name="${name}"]`);
      const prev = tag ? tag.getAttribute("content") : null;
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", name);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
      return prev;
    };

    const prevDesc = setMeta("description", description);

    let canonicalEl = document.querySelector('link[rel="canonical"]');
    const prevCanonical = canonicalEl ? canonicalEl.getAttribute("href") : null;
    if (path) {
      const origin =
        typeof window !== "undefined" ? window.location.origin : "";
      const href = `${origin}${path}`;
      if (!canonicalEl) {
        canonicalEl = document.createElement("link");
        canonicalEl.setAttribute("rel", "canonical");
        document.head.appendChild(canonicalEl);
      }
      canonicalEl.setAttribute("href", href);
    }

    return () => {
      document.title = prevTitle;
      if (prevDesc !== null) {
        const tag = document.querySelector('meta[name="description"]');
        if (tag) tag.setAttribute("content", prevDesc);
      }
      if (canonicalEl && prevCanonical !== null) {
        canonicalEl.setAttribute("href", prevCanonical);
      }
    };
  }, [title, description, path]);
}
